import { render } from "./ButtonAnyNew.vue?vue&type=template&id=8ac8ce2a"
import script from "./ButtonAnyNew.vue?vue&type=script&lang=js"
export * from "./ButtonAnyNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__